import React, { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getScormFilters } from "./scormFilters";
import type { ScormFiltersEnum } from "../../../features/Library/SCORM/types/models";

export interface ScormFilterFormProps extends FilterFormPropsBase<ScormFiltersEnum> {
  disableDateFilters: boolean;
}

const ScormFilterForm: FC<ScormFilterFormProps> = ({ filterOptions, filter, updateFilter, disableDateFilters }) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getScormFilters(true, disableDateFilters)}
  />
);

export default ScormFilterForm;
